import React, { useState, useEffect, useRef } from 'react';

import {
  Modal,
  ModalBody,
  FormGroup,
  Col,
  Row,
  Form,
  ModalHeader,
} from 'react-bootstrap';
import InputMask from 'react-input-mask';
import DatePicker, { registerLocale } from 'react-datepicker';
import validator from 'validator';
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';
import el from 'date-fns/locale/pt-BR';

import MapaService from '../services/MapaService';
import TelegramService from '../services/TelegramService';
import { URL_PAGAMENTO } from '../config/urls';
import { detalhesErroPagamento, mensagemErroPagamento } from '../utils/erroPagamento';

const box = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: 'calc(100% - 120px)',
},
  itemMain = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0',
    width: '100%',
  },
  // New Stepper Styles - Minimalist
  stepContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
    marginBottom: 40,
    marginTop: 10
  },
  stepItem = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 2,
    flex: 1,
  },
  stepCircle = (active, completed) => ({
    width: 32,
    height: 32,
    borderRadius: '50%',
    background: active ? '#dc2626' : completed ? '#1e293b' : '#fff',
    border: active || completed ? 'none' : '2px solid #cbd5e1',
    color: active || completed ? '#fff' : '#94a3b8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 14,
    boxShadow: active ? '0 0 0 4px rgba(220, 38, 38, 0.2)' : 'none',
    transition: 'all 0.3s ease',
  }),
  stepLabel = (active, completed) => ({
    position: 'absolute',
    top: 40,
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    fontSize: 12,
    fontWeight: active ? 700 : 600,
    color: active ? '#0f172a' : completed ? '#475569' : '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    transition: 'all 0.3s ease',
  }),
  stepLine = {
    position: 'absolute',
    top: 16,
    left: 0,
    width: '100%',
    height: 2,
    background: '#e2e8f0',
    zIndex: 1,
  },
  stepLineProgress = (progress) => ({
    position: 'absolute',
    top: 16,
    left: 0,
    width: `${progress}%`,
    height: 2,
    background: '#dc2626',
    zIndex: 1,
    transition: 'width 0.4s ease',
  }),
  itemSeparatorTitle = {
    width: 60,
    height: 4,
    background: '#dc2626',
    marginBottom: 24,
    borderRadius: 2,
  };

export default function ModalPagamento(props) {
  const [contrato, setContrato] = useState(null);
  const [pedido, setPedido] = useState(null);
  const [anos, setAnos] = useState([]);
  const [valorTotal, setValorTotal] = useState(null);
  const passos = [
    'Confirmação do pedido',
    'Forma de pagamento',
    'Dados para pagamento',
  ];
  const [membroComissao, setMembroComissao] = useState(0);
  const [descontoComissao, setDescontoComissao] = useState(0);
  const [numeroParcelasMapa, setNumeroParcelasMapa] = useState(0);
  const [passoSelecionado, setPassoSelecionado] = useState(1);
  const [formaPagamento, setFormaPagamento] = useState('');
  const [parcelasCalculadas, setParcelasCalculadas] = useState([]);
  const [parcelaSelecionada, setParcelaSelecionada] = useState({});
  const [agendamento, setAgendamento] = useState(null);
  const [showModalAlterarData, setShowModalAlterarData] = useState(false);
  const [novaDataPagamento, setNovaDataPagamento] = useState(null);
  const [dataMinimaPagamento, setDataMinimaPagamento] = useState('');
  const [dataMaximaPagamento, setDataMaximaPagamento] = useState('');
  const [podeAlterarAData, setPodeAlterarAData] = useState(true);
  const [showDataTo, setShowDataTo] = useState('fisica');
  const [carregandoFinalizarPedido, setCarregandoFinalizarPedido] =
    useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [stepDadosPagamento, setStepDadosPagamento] = useState('');
  const [infoTitularCartaoCredito, setInfoTitularCartaoCredito] = useState({
    name: '',
    email: '',
    cpfCnpj: '',
    postalCode: '',
    addressNumber: '',
    phone: '',
  });
  const [infoCartaoCredito, setInfoCartaoCredito] = useState({
    holderName: '',
    number: '',
    expiryMonth: '',
    expiryYear: '',
    ccv: '',
  });
  const [exibirAlertaDataInvalida, setExibirAlertaDataInvalida] =
    useState(false);

  const isMountedRef = useRef(true);
  const transitionTimeoutRef = useRef(null);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const { contrato, data, formando } = props,
      windowWidth = window.innerWidth;

    let modalDialog = document.querySelector('#modalPagamento .modal-dialog'),
      modalContent = document.querySelector('#modalPagamento .modal-content'),
      modalBody = document.querySelector('#modalPagamento .modal-body'),
      anoAtual = new Date().getFullYear(),
      auxAnos = [];

    const aplicarEstilos = () => {
      const dialog = document.querySelector('#modalPagamento .modal-dialog');
      const content = document.querySelector('#modalPagamento .modal-content');
      const body = document.querySelector('#modalPagamento .modal-body');
      if (!dialog || !content || !body) return false;
      dialog.style.height = '97vh';
      content.style.height = '100%';
      body.style.height = '100%';
      if (window.innerWidth > 990) {
        dialog.style.width = '55%';
        dialog.style.height = '92vh';
      }
      return true;
    };

    if (!aplicarEstilos()) {
      // DOM ainda não pronto — tenta de novo no próximo frame
      requestAnimationFrame(() => {
        if (!aplicarEstilos()) {
          // Última tentativa após pequeno delay
          setTimeout(aplicarEstilos, 100);
        }
      });
    }

    for (let i = 0; i <= 10; i++) {
      auxAnos.push(anoAtual + i);
    }

    if (!sessionStorage.getItem("ip")) {
      // Usar um serviço para obter o IP do usuário
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          sessionStorage.setItem("ip", data.ip);
        })
        .catch(() => {
          // Fallback: usar um IP padrão em caso de erro
          sessionStorage.setItem("ip", "127.0.0.1");
        });
    }

    setContrato(contrato);
    setPedido(data);
    setAnos(auxAnos);
    setInfoCartaoCredito({
      ...infoCartaoCredito,
      expiryMonth: '01',
      expiryYear: auxAnos[0],
    });
    registerLocale('el', el);
    setMembroComissao(formando.membroComissao);
  }, [props]);

  useEffect(() => {
    let isMounted = true; // Flag para verificar se o componente está montado

    if (pedido) {
      let total = 0,
        desconto = 0,
        mapa = new MapaService();

      // Calcular o total primeiro (independente da API do Mapa)
      pedido.forEach((formando) => {
        formando.itens.forEach((item) => {
          total += item.preco * item.quantidade;
        });
      });


      mapa.consultarDadosPagamentoOrcamento(contrato.numOrcamento).then((response) => {
        if (!isMounted) return; // Não atualiza se o componente foi desmontado

        if (pedido[0].id === 8978) {
          desconto = 50;
        } else {
          desconto = response[0].descontoComissao;
        }

        setDescontoComissao(desconto);
        setNumeroParcelasMapa(response[0].NParcelasBoleto || 12);
        setValorTotal(total);
      }).catch((erro) => {
        if (!isMounted) return; // Não atualiza se o componente foi desmontado

        // Mesmo com erro, define o total e valores padrão
        setDescontoComissao(0);
        setNumeroParcelasMapa(12); // Padrão de 12 parcelas
        setValorTotal(total);
        new TelegramService().novo("ERROR", [JSON.stringify(erro), "Falha ao obter as informações de pagamento", `usuarioLogado: ${JSON.parse(sessionStorage.getItem("usuarioLogadoComissao"))}`]);
      });
    }

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [pedido]);

  useEffect(() => {
    if (parcelaSelecionada > 0) {
      // Validar se contrato tem data máxima
      if (contrato && contrato.dataMaximaPagto) {
        let dataMaxima = new Date(contrato.dataMaximaPagto);

        // Verificar se a data é válida
        if (isNaN(dataMaxima.getTime())) {
          // Mesmo com data inválida, criar agendamento sem validação de prazo
          setPodeAlterarAData(false);
          criarAgendamento();
          return;
        }

        dataMaxima.setDate(dataMaxima.getDate() - (30 * (parcelaSelecionada - 1)));

        if (dataMaxima.getTime() <= new Date().getTime() || ["PIX", "CARTAO_CREDITO"].includes(formaPagamento)) {
          setPodeAlterarAData(false);
        } else {
          setPodeAlterarAData(true);
        }

        setDataMaximaPagamento(splitReverseJoin("/", "-", new Date(dataMaxima).toLocaleDateString("pt-BR")));
      } else {
        // Sem data máxima de pagamento, apenas desabilita alteração
        console.warn("Contrato sem dataMaximaPagto");
        setPodeAlterarAData(false);
      }

      // Sempre criar agendamento se houver parcela selecionada
      criarAgendamento();
    } else {
      setAgendamento(null);
    }
  }, [parcelaSelecionada]);

  useEffect(() => {
    setAgendamento(null);
    // Quando exigirDadosTitular=true (pagamento de rateio), sempre passa pelo
    // step de coletar nome/CPF/email/telefone do pagador, mesmo no PIX.
    const precisaTitular = formaPagamento === 'CARTAO_CREDITO' || props.exigirDadosTitular === true;
    setStepDadosPagamento(precisaTitular ? 'infoTitularCartao' : '');
    setParcelaSelecionada(0);
    if (formaPagamento) {
      handleParcelas();
    }
  }, [formaPagamento, props.exigirDadosTitular]);

  function splitReverseJoin(split, join, data) {
    return data.split(split).reverse().join(join);
  }

  function setUTCHour(data) {
    return new Date(data).setUTCHours(3);
  }

  function criarAgendamento(data = null) {
    // Validar se há parcela selecionada e se parcelasCalculadas está preenchido
    if (!parcelasCalculadas || parcelasCalculadas.length === 0 || !parcelaSelecionada) {
      return;
    }

    let auxParcelaSelecionada = parcelasCalculadas.filter((parcela) => { return parcela.numParcelas === parcelaSelecionada })[0];

    // Validar se encontrou a parcela selecionada
    if (!auxParcelaSelecionada) {
      return;
    }

    let dataAtual = data ? data : { ano: new Date().getFullYear(), mes: new Date().getMonth(), dia: new Date().getDate() },
      auxAgendamento = [];

    for (let i = 0; i < auxParcelaSelecionada.numParcelas; i++) {
      let mes = dataAtual.mes + i,
        dia = dataAtual.dia,
        ultimoDiaMes = new Date(dataAtual.ano, mes + 1, 0).getDate();

      if ((mes === 1 || mes === 13) && dia >= ultimoDiaMes) {
        dia = ultimoDiaMes;
      }

      auxAgendamento.push({
        parcela: i + 1,
        valor: auxParcelaSelecionada.valorParcela,
        data: new Date(dataAtual.ano, mes, dia).toLocaleDateString("pt-BR")
      });
    }
    setAgendamento(auxAgendamento);
  }

  function validarCpf(cpf) {
    var exp = /\.|\-/g;

    cpf = cpf.replace(exp, '').toString();

    if (cpf.length == 11) {
      var v = [];

      //Calcula o primeiro dígito de verificação.
      v[0] = 1 * cpf[0] + 2 * cpf[1] + 3 * cpf[2];
      v[0] += 4 * cpf[3] + 5 * cpf[4] + 6 * cpf[5];
      v[0] += 7 * cpf[6] + 8 * cpf[7] + 9 * cpf[8];
      v[0] = v[0] % 11;
      v[0] = v[0] % 10;

      //Calcula o segundo dígito de verificação.
      v[1] = 1 * cpf[1] + 2 * cpf[2] + 3 * cpf[3];
      v[1] += 4 * cpf[4] + 5 * cpf[5] + 6 * cpf[6];
      v[1] += 7 * cpf[7] + 8 * cpf[8] + 9 * v[0];
      v[1] = v[1] % 11;
      v[1] = v[1] % 10;

      //Retorna Verdadeiro se os dígitos de verificação são os esperados.
      if (v[0] != cpf[9] || v[1] != cpf[10]) {
        return false;
      } else if (
        cpf[0] == cpf[1] &&
        cpf[1] == cpf[2] &&
        cpf[2] == cpf[3] &&
        cpf[3] == cpf[4] &&
        cpf[4] == cpf[5] &&
        cpf[5] == cpf[6] &&
        cpf[6] == cpf[7] &&
        cpf[7] == cpf[8] &&
        cpf[8] == cpf[9] &&
        cpf[9] == cpf[10]
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  function validarCnpj(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    // Valida a quantidade de caracteres
    if (cnpj.length !== 14) {
      return false;
    }

    // Elimina inválidos com todos os caracteres iguais
    if (/^(\d)\1+$/.test(cnpj)) {
      return false;
    }

    // Cáculo de validação
    let t = cnpj.length - 2,
      d = cnpj.substring(t),
      d1 = parseInt(d.charAt(0)),
      d2 = parseInt(d.charAt(1)),
      calc = (x) => {
        let n = cnpj.substring(0, x),
          y = x - 7,
          s = 0,
          r = 0;

        for (let i = x; i >= 1; i--) {
          s += n.charAt(x - i) * y--;
          if (y < 2) y = 9;
        }

        r = 11 - (s % 11);
        return r > 9 ? 0 : r;
      };

    return calc(t) === d1 && calc(t + 1) === d2;
  }

  // Algoritmo de Luhn: reprova um número de cartão digitado errado aqui, em vez
  // de deixar a operadora recusar a cobrança com um erro genérico.
  function validarLuhn(digitos) {
    let soma = 0,
      dobrar = false;

    for (let i = digitos.length - 1; i >= 0; i--) {
      let numero = Number(digitos[i]);

      if (dobrar) {
        numero *= 2;
        if (numero > 9) numero -= 9;
      }

      soma += numero;
      dobrar = !dobrar;
    }

    return soma % 10 === 0;
  }

  // Diz exatamente qual dado está errado. Antes, campos incompletos (CPF pela
  // metade, CEP com 4 dígitos, cartão com número inválido) passavam pela
  // validação e só falhavam na operadora, sem indicar a causa ao formando.
  function mensagemCampoInvalido(nome, valor) {
    let digitos = valor.replace(/\D/g, '');

    switch (nome) {
      case 'cpfCnpj': {
        let ehFisica = showDataTo === 'fisica',
          rotulo = ehFisica ? 'CPF' : 'CNPJ',
          tamanho = ehFisica ? 11 : 14;

        if (digitos.length === 0) return `Informe o ${rotulo} do titular.`;
        if (digitos.length !== tamanho)
          return `O ${rotulo} está incompleto: informe os ${tamanho} dígitos.`;

        return (ehFisica ? validarCpf(valor) : validarCnpj(valor))
          ? ''
          : `O ${rotulo} inserido é inválido!`;
      }
      case 'email':
        if (valor.trim().length === 0) return 'Informe o e-mail do titular.';
        return validator.isEmail(valor) ? '' : 'O e-mail inserido é inválido!';
      case 'phone':
        if (digitos.length === 0) return 'Informe o celular do titular.';
        return digitos.length === 10 || digitos.length === 11
          ? ''
          : 'O celular está incompleto: informe DDD + 8 ou 9 dígitos.';
      case 'postalCode':
        if (digitos.length === 0) return 'Informe o CEP do titular.';
        return digitos.length === 8
          ? ''
          : 'O CEP está incompleto: informe os 8 dígitos.';
      case 'holderName':
        return valor.trim().length >= 3
          ? ''
          : 'Informe o nome do titular exatamente como está impresso no cartão.';
      case 'number':
        if (digitos.length === 0) return 'Informe o número do cartão.';
        if (digitos.length < 13)
          return 'O número do cartão está incompleto: confira os dígitos impressos no cartão.';
        return validarLuhn(digitos)
          ? ''
          : 'O número do cartão é inválido: confira os dígitos impressos no cartão.';
      case 'ccv':
        if (digitos.length === 0) return 'Informe o CVV do cartão.';
        return digitos.length === 3 || digitos.length === 4
          ? ''
          : 'O CVV deve ter 3 ou 4 dígitos (código de segurança do cartão).';
      default:
        return '';
    }
  }

  function validarInputs(campos) {
    limparHelpBlock();

    let status = true;

    campos.forEach((campo) => {
      let nome = String(campo.name),
        valor = String(campo.value),
        mensagem = mensagemCampoInvalido(nome, valor);

      if (!mensagem && !campo.checkValidity()) {
        mensagem = campo.validationMessage;
      }

      if (mensagem) {
        campo.closest('div').appendChild(criarSpan(mensagem));
        status = false;
      }
    });

    return status;
  }

  function criarSpan(texto) {
    let span = document.createElement('span');
    span.textContent = texto;
    span.classList.add('help-block');

    return span;
  }

  function limparHelpBlock() {
    try {
      const helpBlocks = document.querySelectorAll(".help-block");
      helpBlocks.forEach((item) => {
        // Verificar se o elemento ainda existe e tem um pai antes de remover
        if (item && item.parentNode) {
          try {
            // Use remove() ao invés de removeChild() para evitar conflitos
            item.remove();
          } catch (e) {
            // Se falhar, tenta com removeChild
            try {
              if (item.parentNode.contains(item)) {
                item.parentNode.removeChild(item);
              }
            } catch (err) {
              // Ignora erros silenciosamente
            }
          }
        }
      });
    } catch (error) {
      // Silenciar erros de remoção de elementos que já não existem no DOM
    }
  }

  function handleSubmitFormaPagamento(e) {
    e.preventDefault();

    // No PIX a parcela (1x) é definida automaticamente. Nas demais formas o
    // usuário precisa escolher o número de parcelas antes de avançar, senão o
    // agendamento não é criado e o pedido falha ao finalizar.
    if (formaPagamento !== "PIX" && !parcelaSelecionada) {
      alert("Por favor, escolha o número de parcelas antes de continuar.");
      return;
    }

    setPassoSelecionado(passoSelecionado + 1);
  }

  function handleSubmitPagamento() {
    setCarregandoFinalizarPedido(true);

    // Validar se o agendamento foi criado
    if (!agendamento || agendamento.length === 0) {
      console.error("Agendamento não foi criado");
      alert("Erro: não foi possível criar o agendamento de pagamento. Por favor, tente novamente.");
      setCarregandoFinalizarPedido(false);
      return;
    }

    // Validar se o contrato tem data máxima de pagamento válida
    const dataMaximaContrato = contrato && contrato.dataMaximaPagto ? new Date(contrato.dataMaximaPagto) : null;
    const dataUltimaParcela = agendamento && agendamento.length > 0 ? new Date(splitReverseJoin("/", "-", agendamento[agendamento.length - 1].data)) : null;

    // Verificar se as datas são válidas
    const dataValida = !dataMaximaContrato || !dataUltimaParcela || isNaN(dataMaximaContrato.getTime()) || dataUltimaParcela.getTime() <= dataMaximaContrato.getTime();

    if ((formaPagamento === "PIX" && dataValida) || formaPagamento === "CARTAO_CREDITO") {

      // Garantir que o IP existe antes de enviar
      let ipUsuario = sessionStorage.getItem("ip");
      if (!ipUsuario || ipUsuario === "null" || ipUsuario === "undefined") {
        ipUsuario = "127.0.0.1"; // Fallback para IP local
      }

      let payload = {
        contrato: contrato.numero,
        formaPagamento: formaPagamento,
        dtVencimento: splitReverseJoin("/", "-", agendamento[0].data),
        formandoId: pedido[0].id,
        itens: [],
        numParcelas: parcelaSelecionada,
        remoteIp: ipUsuario
      };

      pedido[0].itens.forEach((item) => {
        let preco = item.quantidade * item.preco;

        if (membroComissao) {
          preco = (preco - (preco * (descontoComissao / 100)));
        }

        payload.itens.push({ nome: item.produto, quantidade: item.quantidade, valor: preco, ext_ref: item.idProduto });
      });

      if (formaPagamento === "CARTAO_CREDITO") {
        payload.creditCard = infoCartaoCredito;
        payload.creditCardHolderInfo = infoTitularCartaoCredito;
      } else if (props.exigirDadosTitular === true) {
        // PIX/boleto em pagamento de rateio: registra dados do pagador externo
        // na cobranca, mesmo sem dados de cartao.
        payload.creditCardHolderInfo = infoTitularCartaoCredito;
      }

      axios.post(`${URL_PAGAMENTO}/novo-pedido`, payload, { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('tokenPagamento') } }).then((response) => {
        let auxPayload = Object.assign({}, payload);
        auxPayload.creditCard = "";
        auxPayload.creditCardHolderInfo = "";
        new TelegramService().novo("INFO", ["----- NOVO PEDIDO -----", JSON.stringify(auxPayload), "----- PARCELAS -----", JSON.stringify(agendamento), `usuarioLogado: ${sessionStorage.getItem("usuarioLogadoComissao")}`]);

        // Respostas fora do 2xx chegavam aqui como sucesso e o formando não via
        // aviso nenhum; agora o motivo devolvido pela API é repassado à tela.
        if (response.status !== 201 && response.status !== 200) {
          const mensagem = mensagemErroPagamento(response.data);

          console.error(`Pedido não criado (HTTP ${response.status}): ${mensagem}`);
          props.close({ status: response.status, mensagemErro: mensagem, formaPagamento });
          return;
        }

        props.close({ ...response, formaPagamento });
      }).catch((erro) => {
        let auxPayload = Object.assign({}, payload);
        auxPayload.creditCard = "";
        auxPayload.creditCardHolderInfo = "";

        // A causa real (CPF recusado, cartão inválido, sessão expirada...) vem
        // na resposta da API. Antes ela era descartada e a tela exibia sempre
        // "tente novamente mais tarde", sem dizer o que corrigir.
        const mensagem = mensagemErroPagamento(erro),
          detalhes = detalhesErroPagamento(erro);

        console.error('Falha ao finalizar o pedido:\n' + detalhes);
        new TelegramService().novo("ERROR", [detalhes, "Novo pedido - formando", JSON.stringify(auxPayload), `usuarioLogado: ${sessionStorage.getItem("usuarioLogadoComissao")}`]);
        props.close({ status: (erro.response && erro.response.status) || 500, mensagemErro: mensagem, formaPagamento });
      });
    } else {
      setPassoSelecionado(passoSelecionado - 1);
      setCarregandoFinalizarPedido(false);
      setExibirAlertaDataInvalida(true);
    }
  }

  function handleSubmitAlterarDataPagamento(e) {
    e.preventDefault();

    let dataSeparada = new Date(setUTCHour(novaDataPagamento)),
      data = {
        ano: dataSeparada.getFullYear(),
        mes: dataSeparada.getMonth(),
        dia: dataSeparada.getDate(),
      };

    criarAgendamento(data);
    setShowModalAlterarData(false);
  }

  function handleCreateFormaPagamento() {
    let dataMaximaParcelamento = new Date(setUTCHour(contrato.dataMaximaPagto));
    dataMaximaParcelamento = new Date(
      new Date(dataMaximaParcelamento).setHours(0, 0, 0, 0)
    );

    const dataAtual = new Date().getTime();
    const dataAtualEhAnteriorQueARecente =
      dataAtual < dataMaximaParcelamento.getTime();

    const dataMaximaParcelamentoMais30Dias = dataMaximaParcelamento;

    dataMaximaParcelamentoMais30Dias.setDate(
      dataMaximaParcelamentoMais30Dias.getDate() + 30
    );

    if (
      valorTotal >= 50 &&
      (dataAtualEhAnteriorQueARecente ||
        dataAtual <= dataMaximaParcelamentoMais30Dias.getTime())
    ) {
      let auxFormaPagamento = [
        { label: 'PIX', value: 'PIX' },
        { label: 'Cartão de crédito', value: 'CARTAO_CREDITO' },
        { label: 'Boleto à vista', value: 'BOLETO' },
      ];

      if (contrato.parcelamentoNoBoleto === 1) {
        auxFormaPagamento = [
          ...auxFormaPagamento,
          { label: 'Parcelamento no boleto', value: 'PARCELAMENTO_BOLETO' },
        ];
      }
      return auxFormaPagamento;
    }
    return [{ label: 'PIX', value: 'PIX' }];
  }

  function handleParcelas() {

    let total = membroComissao ? valorTotal - (valorTotal * (descontoComissao / 100)) : valorTotal;

    if (formaPagamento === "PIX") {
      setParcelasCalculadas([{ numParcelas: 1, valorParcela: total }]);
      setParcelaSelecionada(1); // Define automaticamente 1 parcela
      setDataMinimaPagamento(splitReverseJoin("/", "-", new Date().toLocaleDateString("pt-BR")));
      return; // Para a execução aqui
    }

    let parcelas = 0,
      valorMinimoParcela = formaPagamento === "CARTAO_CREDITO" ? 5 : 50,
      parcelasPermitidas = Math.trunc(total / valorMinimoParcela),
      parcelasArr = [{ numParcelas: 1, valorParcela: total }];

    parcelas = numeroParcelasMapa;

    if (parcelas > parcelasPermitidas) {
      parcelas = parcelasPermitidas;
    }

    let dataMaximaParcelamento = null;
    if (contrato && contrato.dataMaximaPagto) {
      dataMaximaParcelamento = new Date(setUTCHour(contrato.dataMaximaPagto));
      if (!isNaN(dataMaximaParcelamento.getTime())) {
        dataMaximaParcelamento = new Date(new Date(dataMaximaParcelamento).setHours(0, 0, 0, 0));
      } else {
        console.warn("Data máxima de parcelamento inválida");
        dataMaximaParcelamento = null;
      }
    }

    for (let i = 2; i <= parcelas; i++) {
      let dataInicialParcelamento = new Date(new Date().setHours(0, 0, 0, 0));

      dataInicialParcelamento.setDate(dataInicialParcelamento.getDate() + (30 * (i - 1)));


      if (formaPagamento === "CARTAO_CREDITO" ||
        !dataMaximaParcelamento ||
        (dataInicialParcelamento.getTime() <= dataMaximaParcelamento.getTime())) {
        parcelasArr.push({ numParcelas: i, valorParcela: total / i });
      }
    }

    setDataMinimaPagamento(splitReverseJoin("/", "-", new Date().toLocaleDateString("pt-BR")));
    setParcelasCalculadas(parcelasArr);
  }

  function handleChangeFormaPagamento(e) {
    const { value } = e.target;
    setFormaPagamento(value);
    setParcelaSelecionada(0);
  }

  function handleChangeNumeroParcelasSelecionadas(e) {
    const { value } = e.target;
    setParcelaSelecionada(Number(value));
  }

  function handleChangeInfoTitularCartao(e) {
    const { name, value } = e.target;

    setInfoTitularCartaoCredito({ ...infoTitularCartaoCredito, [name]: value });
  }

  function handleChangeInfoCartao(e) {
    const { name, value } = e.target;
    // Número e CVV vão para a operadora sem máscara: espaços ou pontos
    // digitados pelo formando faziam a cobrança ser recusada.
    const valor =
      name === 'number' || name === 'ccv' ? value.replace(/\D/g, '') : value;

    setInfoCartaoCredito({ ...infoCartaoCredito, [name]: valor });
  }

  function handleFinishedInfoTitularCartao() {
    let campos = document.querySelectorAll('#boxInfoTitularCartao input');

    if (validarInputs(campos) && !isTransitioning) {
      // Se nao for cartao (ex: PIX em pagamento de rateio), pula o passo de
      // dados de cartao e vai direto para finalizar o pedido.
      if (formaPagamento !== 'CARTAO_CREDITO') {
        handleSubmitPagamento();
        return;
      }
      setIsTransitioning(true);
      // Clear any existing timeout
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
      // Add delay to allow React to complete DOM reconciliation
      transitionTimeoutRef.current = setTimeout(() => {
        if (isMountedRef.current) {
          setStepDadosPagamento('infoCartao');
          setIsTransitioning(false);
        }
      }, 200);
    }
  }

  // A validade vem pré-selecionada em 01/ano atual, que já está vencida na
  // maior parte do ano: sem esta checagem a operadora recusava a cobrança e a
  // tela só dizia "tente novamente mais tarde".
  function cartaoVencido() {
    let mes = Number(infoCartaoCredito.expiryMonth),
      ano = Number(infoCartaoCredito.expiryYear);

    if (!mes || !ano) return false;

    // Dia 0 do mês seguinte = último dia do mês da validade.
    return new Date(ano, mes, 0, 23, 59, 59).getTime() < new Date().getTime();
  }

  function handleFinishedInfoCartao() {
    let campos = document.querySelectorAll('#boxInfoCartao input');

    if (!validarInputs(campos)) return;

    if (cartaoVencido()) {
      alert(
        `A validade informada (${infoCartaoCredito.expiryMonth}/${infoCartaoCredito.expiryYear}) já passou. Confira o mês e o ano impressos no cartão.`
      );
      return;
    }

    handleSubmitPagamento();
  }

  function _renderStepsHeader() {
    const progress = ((passoSelecionado - 1) / (passos.length - 1)) * 100;

    return (
      <div
        style={{
          padding: '32px 32px 40px',
          background: '#fff',
          borderBottom: '1px solid #f1f5f9',
          position: 'relative'
        }}
      >
        <div style={stepContainer}>
          <div style={stepLine}></div>
          <div style={stepLineProgress(progress)}></div>

          {passos.map((item, i) => {
            const stepNum = i + 1;
            const ativo = stepNum === passoSelecionado;
            const concluido = passoSelecionado > stepNum;

            return (
              <div key={item} style={stepItem}>
                <div style={stepCircle(ativo, concluido)}>
                  <i className='fa fa-check' style={{
                    opacity: concluido ? 1 : 0,
                    visibility: concluido ? 'visible' : 'hidden',
                    position: concluido ? 'static' : 'absolute'
                  }}></i>
                  <span style={{
                    opacity: concluido ? 0 : 1,
                    visibility: concluido ? 'hidden' : 'visible'
                  }}>{stepNum}</span>
                </div>
                <div style={stepLabel(ativo, concluido)}>
                  {item}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  function _renderPedido() {
    // Verifica se pedido existe e é válido
    if (!pedido || !Array.isArray(pedido) || pedido.length === 0) {
      return (
        <div style={box} key="loading-pedido">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '40px'
            }}
          >
            <span style={{ marginRight: '10px' }}>
              <i className='fa fa-spinner fa-spin'></i>
            </span>
            Carregando...
          </div>
        </div>
      );
    }

    return (
      <div style={box}>
        {pedido && Array.isArray(pedido) && pedido.length > 0 ? (
          <React.Fragment>
            <div>
              <h4 style={{
                color: '#2c3e50',
                fontWeight: '700',
                fontSize: '20px',
                marginBottom: '15px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <i className='fa fa-shopping-bag' style={{ color: '#dc3545' }}></i>
                Confirme o seu pedido
              </h4>
              <div style={itemSeparatorTitle}></div>
              <div className='table-responsive' style={{
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }}>
                <table style={{
                  width: '100%',
                  marginBottom: 0,
                  borderCollapse: 'collapse'
                }}>
                  <thead>
                    <tr style={{
                      background: '#f8fafc',
                      borderBottom: '1px solid #e2e8f0'
                    }}
                    >
                      <th style={{
                        padding: '16px 24px',
                        fontWeight: '600',
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b'
                      }}>Formando</th>
                      <th style={{
                        padding: '16px 24px',
                        fontWeight: '600',
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b'
                      }}>Produto</th>
                      <th style={{
                        padding: '16px 24px',
                        fontWeight: '600',
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b',
                        textAlign: 'center'
                      }}>Qtd</th>
                      <th style={{
                        padding: '16px 24px',
                        fontWeight: '600',
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b',
                        textAlign: 'right'
                      }}>Unitário</th>
                      <th style={{
                        padding: '16px 24px',
                        fontWeight: '600',
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b',
                        textAlign: 'right'
                      }}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/*
                      Para pagamento de rateio, pedido[0].linhasExibicao detalha o
                      excedente por formando (mostrar certo). O payload de cobrança
                      continua usando pedido[0].itens (agregado, no nome do pagador).
                      Fora do rateio, cai no comportamento original (pedido[].itens).
                    */}
                    {(pedido[0] && pedido[0].linhasExibicao ? pedido[0].linhasExibicao : pedido).map((formando, fi) => {
                      return formando.itens.map((item, i) => (
                        <tr key={`${fi}-${i}`} style={{
                          borderBottom: '1px solid #f1f5f9',
                          background: 'white'
                        }}>
                          <td style={{
                            padding: '16px 24px',
                            verticalAlign: 'middle',
                            fontSize: '14px',
                            color: '#0f172a',
                            fontWeight: '600'
                          }}> {formando.nome} </td>
                          <td style={{
                            padding: '16px 24px',
                            verticalAlign: 'middle',
                            fontSize: '14px',
                            color: '#475569'
                          }}> {String(item.produto || '').replace('[RATEIO] ', '')} </td>
                          <td style={{
                            padding: '16px 24px',
                            verticalAlign: 'middle',
                            fontSize: '14px',
                            color: '#475569',
                            textAlign: 'center',
                            fontWeight: '600'
                          }}> {item.quantidade} </td>
                          <td style={{
                            padding: '16px 24px',
                            verticalAlign: 'middle',
                            fontSize: '14px',
                            color: '#475569',
                            textAlign: 'right'
                          }}> R$ {props.formatarMoedaBR(item.preco)} </td>
                          <td style={{
                            padding: '16px 24px',
                            verticalAlign: 'middle',
                            fontSize: '15px',
                            color: '#dc2626',
                            fontWeight: '700',
                            textAlign: 'right'
                          }}> R$ {props.formatarMoedaBR(item.total)} </td>
                        </tr>
                      ));
                    })}
                  </tbody>
                  {membroComissao && descontoComissao > 0 ? (
                    <tfoot>
                      <tr style={{ background: '#f8fafc' }}>
                        <td
                          colSpan={4}
                          style={{
                            color: '#64748b',
                            fontWeight: 600,
                            textAlign: 'right',
                            padding: '16px 24px',
                            fontSize: '14px',
                            borderTop: '1px solid #e2e8f0'
                          }}
                        >
                          Subtotal
                        </td>
                        <td style={{
                          color: '#334155',
                          fontWeight: 700,
                          padding: '16px 24px',
                          fontSize: '15px',
                          borderTop: '1px solid #e2e8f0',
                          textAlign: 'right'
                        }}>
                          R$ {props.formatarMoedaBR(valorTotal)}
                        </td>
                      </tr>
                      <tr style={{ background: '#f0fdf4' }}>
                        <td
                          colSpan={4}
                          style={{
                            color: '#166534',
                            fontWeight: 600,
                            textAlign: 'right',
                            padding: '16px 24px',
                            fontSize: '14px',
                            borderTop: '1px solid #bbf7d0'
                          }}
                        >
                          <i className='fa fa-tag' style={{ marginRight: '8px' }}></i>
                          Desconto Comissão ({descontoComissao}%)
                        </td>
                        <td style={{
                          color: '#166534',
                          fontWeight: 700,
                          padding: '16px 24px',
                          fontSize: '15px',
                          borderTop: '1px solid #bbf7d0',
                          textAlign: 'right'
                        }}>
                          - R${' '}
                          {props.formatarMoedaBR(
                            valorTotal * (descontoComissao / 100)
                          )}
                        </td>
                      </tr>
                      <tr style={{
                        background: '#fff'
                      }}>
                        <td
                          colSpan={4}
                          style={{
                            color: '#0f172a',
                            fontWeight: 700,
                            textAlign: 'right',
                            padding: '24px',
                            fontSize: '16px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase'
                          }}
                        >
                          Total Final
                        </td>
                        <td style={{
                          color: '#dc2626',
                          fontWeight: 800,
                          padding: '24px',
                          fontSize: '24px',
                          textAlign: 'right'
                        }}>
                          R${' '}
                          {props.formatarMoedaBR(
                            valorTotal - valorTotal * (descontoComissao / 100)
                          )}
                        </td>
                      </tr>
                    </tfoot>
                  ) : (
                    <tfoot>
                      <tr style={{
                        background: '#fff',
                        borderTop: '1px solid #e2e8f0'
                      }}>
                        <td
                          colSpan={4}
                          style={{
                            color: '#0f172a',
                            fontWeight: 700,
                            textAlign: 'right',
                            padding: '24px',
                            fontSize: '16px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase'
                          }}
                        >
                          Total Final
                        </td>
                        <td style={{
                          color: '#dc2626',
                          fontWeight: 800,
                          padding: '24px',
                          fontSize: '24px',
                          textAlign: 'right'
                        }}>
                          R$ {props.formatarMoedaBR(valorTotal)}
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '25px' }}>
              <button
                className="btn-proximo"
                style={{
                  background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                  color: 'white',
                  padding: '12px 35px',
                  fontSize: '15px',
                  fontWeight: '600',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onClick={() => setPassoSelecionado(passoSelecionado + 1)}
              >
                Próximo
                <i className='fa fa-arrow-right'></i>
              </button>
            </div>
          </React.Fragment>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {' '}
            <i className='fa fa-spinner fa-spin' /> Aguarde
          </div>
        )}
      </div>
    );
  }

  function _renderFormaPagamento() {
    const formatarDataMaxima = () => {
      if (contrato && contrato.dataMaximaPagto) {
        const data = new Date(setUTCHour(contrato.dataMaximaPagto));
        if (!isNaN(data.getTime())) {
          return data.toLocaleDateString("pt-BR");
        }
      }
      return "data não definida";
    };

    return (
      <React.Fragment>
        {exibirAlertaDataInvalida ? (
          <div style={{
            background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
            color: '#991b1b',
            padding: '16px 20px',
            borderRadius: '12px',
            marginBottom: '24px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '14px',
            border: '1px solid #fca5a5',
            boxShadow: '0 4px 12px rgba(220, 53, 69, 0.15)',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            <i className="fa fa-exclamation-triangle" style={{ fontSize: '22px', marginTop: '2px', color: '#dc2626' }} />
            <div>
              <div style={{ fontWeight: '700', marginBottom: '4px' }}>Data inválida</div>
              A data de pagamento selecionada excede o prazo permitido ({formatarDataMaxima()})
            </div>
          </div>
        ) : null}
        <Form style={box} onSubmit={handleSubmitFormaPagamento}>
          <div>
            <h4 style={{
              color: '#1e293b',
              fontWeight: '700',
              fontSize: '22px',
              marginBottom: '24px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <div style={{
                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                width: '44px',
                height: '44px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(220, 53, 69, 0.25)'
              }}>
                <i className='fa fa-credit-card' style={{ color: 'white', fontSize: '20px' }}></i>
              </div>
              <span>Escolha a forma de pagamento</span>
            </h4>
            <Row>
              <Col sm={12}>
                <FormGroup>
                  <label style={{
                    color: '#334155',
                    fontWeight: '600',
                    fontSize: '14px',
                    marginBottom: '12px',
                    display: 'block',
                    letterSpacing: '0.2px'
                  }}>
                    <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                    Selecione o método de pagamento
                  </label>
                  {/*
                    FORMAS DE PAGAMENTO DISPONÍVEIS:
                    - PIX: disponível para todos os valores
                    - CARTÃO DE CRÉDITO: apenas para valores >= R$ 50,00

                    IMPORTANTE: Boleto bancário foi removido do front-end mas continua
                    disponível no backend para manter histórico de pagamentos antigos.
                    Token Asaas é gerenciado apenas no servidor (não exposto no client).
                  */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                    <div
                      onClick={() => handleChangeFormaPagamento({ target: { value: 'PIX' } })}
                      className={formaPagamento === 'PIX' ? 'payment-card-selected' : 'payment-card'}
                      style={{
                        padding: '14px 16px',
                        border: formaPagamento === 'PIX' ? '2px solid #dc3545' : '1px solid #e2e8f0',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        background: formaPagamento === 'PIX' ? '#fff5f5' : 'white',
                        boxShadow: formaPagamento === 'PIX' ? '0 2px 8px rgba(220, 53, 69, 0.1)' : 'none',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '6px',
                          background: formaPagamento === 'PIX' ? '#10b981' : '#f1f5f9',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                          transition: 'all 0.2s ease'
                        }}>
                          <i className='fa fa-qrcode' style={{
                            color: formaPagamento === 'PIX' ? 'white' : '#64748b',
                            fontSize: '14px'
                          }}></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: '600', fontSize: '14px', color: '#1e293b', marginBottom: '2px' }}>PIX</div>
                          <div style={{ fontSize: '11px', color: '#64748b' }}>Aprovação instantânea</div>
                        </div>
                        <i className='fa fa-check-circle' style={{
                          color: '#dc3545',
                          fontSize: '16px',
                          opacity: formaPagamento === 'PIX' ? 1 : 0,
                          visibility: formaPagamento === 'PIX' ? 'visible' : 'hidden',
                          transition: 'opacity 0.2s ease'
                        }}></i>
                      </div>
                    </div>

                    <div
                      onClick={() => handleChangeFormaPagamento({ target: { value: 'CARTAO_CREDITO' } })}
                      className={formaPagamento === 'CARTAO_CREDITO' ? 'payment-card-selected' : 'payment-card'}
                      style={{
                        padding: '14px 16px',
                        border: formaPagamento === 'CARTAO_CREDITO' ? '2px solid #dc3545' : '1px solid #e2e8f0',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        background: formaPagamento === 'CARTAO_CREDITO' ? '#fff5f5' : 'white',
                        boxShadow: formaPagamento === 'CARTAO_CREDITO' ? '0 2px 8px rgba(220, 53, 69, 0.1)' : 'none',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '6px',
                          background: formaPagamento === 'CARTAO_CREDITO' ? '#3b82f6' : '#f1f5f9',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                          transition: 'all 0.2s ease'
                        }}>
                          <i className='fa fa-credit-card' style={{
                            color: formaPagamento === 'CARTAO_CREDITO' ? 'white' : '#64748b',
                            fontSize: '14px'
                          }}></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: '600', fontSize: '14px', color: '#1e293b', marginBottom: '2px' }}>Cartão de Crédito</div>
                          <div style={{ fontSize: '11px', color: '#64748b' }}>Parcele em até {numeroParcelasMapa}x</div>
                        </div>
                        <i className='fa fa-check-circle' style={{
                          color: '#dc3545',
                          fontSize: '16px',
                          opacity: formaPagamento === 'CARTAO_CREDITO' ? 1 : 0,
                          visibility: formaPagamento === 'CARTAO_CREDITO' ? 'visible' : 'hidden',
                          transition: 'opacity 0.2s ease'
                        }}></i>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            {
              formaPagamento && formaPagamento !== "PIX" ?
                <Row style={{ marginTop: '24px' }}>
                  <Col sm={12}>
                    <FormGroup>
                      <label style={{
                        color: '#334155',
                        fontWeight: '600',
                        fontSize: '14px',
                        marginBottom: '12px',
                        display: 'block',
                        letterSpacing: '0.2px'
                      }}>
                        <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                        Escolha o número de parcelas
                      </label>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '10px' }}>
                        {parcelasCalculadas.map((item, i) => (
                          <div
                            key={i}
                            onClick={() => handleChangeNumeroParcelasSelecionadas({ target: { value: item.numParcelas } })}
                            style={{
                              padding: '12px',
                              border: parcelaSelecionada === item.numParcelas ? '2px solid #dc3545' : '1px solid #e2e8f0',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              background: parcelaSelecionada === item.numParcelas ? '#fff5f5' : 'white',
                              boxShadow: parcelaSelecionada === item.numParcelas ? '0 2px 8px rgba(220, 53, 69, 0.1)' : 'none',
                              position: 'relative',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              textAlign: 'center'
                            }}
                          >
                            <div style={{
                              position: 'absolute',
                              top: '6px',
                              right: '6px',
                              width: '18px',
                              height: '18px',
                              display: 'flex',
                              background: '#dc3545',
                              borderRadius: '50%',
                              alignItems: 'center',
                              justifyContent: 'center',
                              opacity: parcelaSelecionada === item.numParcelas ? 1 : 0,
                              visibility: parcelaSelecionada === item.numParcelas ? 'visible' : 'hidden',
                              transition: 'all 0.2s ease'
                            }}>
                              <i className='fa fa-check' style={{ color: 'white', fontSize: '10px' }}></i>
                            </div>
                            <div style={{ fontSize: '18px', fontWeight: '700', color: '#1e293b', marginBottom: '4px' }}>
                              {item.numParcelas}x
                            </div>
                            <div style={{ fontSize: '13px', color: '#64748b', fontWeight: '600' }}>
                              R$ {props.formatarMoedaBR(item.valorParcela)}
                            </div>
                            <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>
                              sem juros
                            </div>
                          </div>
                        ))}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                : null
            }
            {
              agendamento ?
                <Row style={{ marginTop: '24px' }}>
                  <Col sm={12}>
                    <FormGroup>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px',
                        flexWrap: 'wrap',
                        gap: '12px'
                      }}>
                        <label style={{
                          color: '#334155',
                          fontWeight: '600',
                          fontSize: '14px',
                          margin: 0,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          letterSpacing: '0.2px'
                        }}>
                          <i className='fa fa-calendar-check' style={{ color: '#dc3545', fontSize: '16px' }}></i>
                          Resumo do agendamento
                        </label>
                        {podeAlterarAData ? (
                          <button
                            type="button"
                            onClick={() => setShowModalAlterarData(true)}
                            className="btn-alterar-data"
                            style={{
                              background: 'transparent',
                              color: '#dc3545',
                              border: '2px solid #dc3545',
                              padding: '6px 14px',
                              borderRadius: '8px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: '600',
                              transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}
                          >
                            <i className='fa fa-edit'></i>
                            Alterar data
                          </button>
                        ) : null}
                      </div>
                      <div style={{
                        background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                        padding: '20px',
                        borderRadius: '12px',
                        border: '2px solid #e2e8f0',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                      }}>
                        {agendamento.map((item, i) => (
                          <div key={i} style={{
                            padding: '14px 16px',
                            marginBottom: i < agendamento.length - 1 ? '10px' : '0',
                            borderRadius: '10px',
                            background: 'white',
                            border: '1px solid #e2e8f0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '12px',
                            transition: 'all 0.2s ease'
                          }}
                            className="agendamento-card"
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <div style={{
                                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                width: '36px',
                                height: '36px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: '700',
                                fontSize: '14px',
                                boxShadow: '0 4px 8px rgba(220, 53, 69, 0.25)'
                              }}>
                                {item.parcela}
                              </div>
                              <div>
                                <div style={{ fontSize: '12px', color: '#64748b', fontWeight: '500' }}>
                                  {item.parcela}° Parcela
                                </div>
                                <div style={{ fontSize: '13px', color: '#334155', fontWeight: '600', marginTop: '2px' }}>
                                  <i className='fa fa-calendar' style={{ color: '#94a3b8', marginRight: '6px', fontSize: '12px' }}></i>
                                  {item.data}
                                </div>
                              </div>
                            </div>
                            <div style={{
                              fontSize: '18px',
                              color: '#1e293b',
                              fontWeight: '700',
                              padding: '8px 14px',
                              background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                              borderRadius: '8px',
                              border: '1px solid #fecaca'
                            }}>
                              R$ {props.formatarMoedaBR(item.valor)}
                            </div>
                          </div>
                        ))}
                        {agendamento.length > 1 && (
                          <div style={{
                            marginTop: '16px',
                            padding: '12px 16px',
                            background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
                            borderRadius: '10px',
                            border: '1px solid #86efac',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            fontSize: '13px',
                            color: '#166534',
                            fontWeight: '600'
                          }}>
                            <i className='fa fa-info-circle' style={{ fontSize: '16px' }}></i>
                            <span>Pagamento parcelado em {agendamento.length}x sem juros</span>
                          </div>
                        )}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                : null
            }
          </div>
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: '15px',
            marginTop: '20px'
          }}>
            <button
              type="button"
              className="btn-voltar"
              style={{
                background: 'transparent',
                color: '#6c757d',
                padding: '10px 25px',
                fontSize: '14px',
                fontWeight: '600',
                border: '2px solid #e9ecef',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onClick={() => setPassoSelecionado(passoSelecionado - 1)}
            >
              <i className='fa fa-arrow-left'></i>
              Voltar
            </button>
            <button
              type="submit"
              className="btn-proximo"
              style={{
                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                color: 'white',
                padding: '12px 35px',
                fontSize: '15px',
                fontWeight: '600',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              Próximo
              <i className='fa fa-arrow-right'></i>
            </button>
          </div>
        </Form>
        <Modal show={showModalAlterarData} onHide={() => setShowModalAlterarData(false)} animation={false}>
          <ModalHeader closeButton>Alteração da data de pagamento</ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmitAlterarDataPagamento}>
              <div className="alert alert-info" style={{ fontSize: 14 }}>
                <p style={{ marginBottom: 5 }}><i style={{ marginRight: 5 }} className="fa fa-info-circle"></i> ATENÇÃO:</p>
                <p style={{ marginBottom: 5 }}>Escolha a data da primeira parcela no campo abaixo. Você poderá escolher uma data que esteja entre <strong>{splitReverseJoin("-", "/", dataMinimaPagamento)}</strong> e <strong>{splitReverseJoin("-", "/", dataMaximaPagamento)}</strong>.</p>
                <p>OBS: Caso você tenha mais de uma parcela, elas serão agendadas para pagamento nos meses seguintes.</p>
              </div>

              <label><span className="perguntaObrigatoria">*</span>Data da primeira parcela</label>
              <Row>
                <FormGroup>
                  <Col xs={12}>
                    <DatePicker
                      selected={novaDataPagamento}
                      className="form-control"
                      onChange={date => setNovaDataPagamento(date)}
                      dateFormat="dd/MM/yyyy"
                      locale="el"
                      filterDate={date => { return new Date(setUTCHour(date)).getTime() >= new Date(setUTCHour(dataMinimaPagamento)).getTime() && new Date(setUTCHour(date)).getTime() <= new Date(setUTCHour(dataMaximaPagamento)).getTime() }}
                      placeholderText="Selecione uma data"
                      required
                    />
                    <button style={{ margin: "0 0 4px 15px" }} className="btn btn-success btn-flat" button="submit">Alterar</button>
                  </Col>
                </FormGroup>
              </Row>
            </Form>
          </ModalBody>
        </Modal>
      </React.Fragment>
    )
  }

  function _renderItensFormaPagamento() {
    const itens = handleCreateFormaPagamento();
    return itens.map((item) => (
      <option key={item.value} value={item.value}>
        {item.label}
      </option>
    ));
  }

  function _renderDadosPagamento() {
    return (
      <React.Fragment>
        <div id='boxInfoTitularCartao' style={{
          display: stepDadosPagamento === 'infoTitularCartao' ? 'block' : 'none'
        }}>
            <div style={{ marginBottom: '24px' }}>
              <h5 style={{
                color: '#1e293b',
                fontWeight: '600',
                fontSize: '16px',
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <i className='fa fa-user' style={{ color: '#dc3545' }}></i>
                Informações do titular do cartão
              </h5>
              <p style={{ color: '#64748b', fontSize: '13px', margin: 0 }}>
                Preencha os dados do responsável pelo pagamento
              </p>
            </div>

            <div>
              <Row style={{ marginBottom: '16px' }}>
                <Col sm={12}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '8px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Eu vou pagar como:
                    </label>
                    <div style={{ display: 'flex', gap: '16px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer',
                        fontWeight: '400',
                        fontSize: '14px',
                        color: '#475569'
                      }}>
                        <input
                          type='radio'
                          name='pessoa'
                          onChange={() => setShowDataTo('fisica')}
                          checked={showDataTo === 'fisica'}
                          style={{ cursor: 'pointer' }}
                        />
                        pessoa física
                      </label>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer',
                        fontWeight: '400',
                        fontSize: '14px',
                        color: '#475569'
                      }}>
                        <input
                          type='radio'
                          name='pessoa'
                          onChange={() => setShowDataTo('juridica')}
                          checked={showDataTo === 'juridica'}
                          style={{ cursor: 'pointer' }}
                        />
                        pessoa jurídica
                      </label>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={8}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='nome' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Nome:
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='name'
                      id='nome'
                      value={infoTitularCartaoCredito.name}
                      onChange={(e) => handleChangeInfoTitularCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={12} md={4}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='email' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      E-mail:
                    </label>
                    <input
                      type='email'
                      className='form-control'
                      name='email'
                      id='email'
                      value={infoTitularCartaoCredito.email}
                      onChange={(e) => handleChangeInfoTitularCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='cpfCnpj' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      {showDataTo === 'fisica' ? 'CPF' : 'CNPJ'}:
                    </label>
                    <InputMask
                      className='form-control'
                      name='cpfCnpj'
                      id='cpfCnpj'
                      value={infoTitularCartaoCredito.cpfCnpj}
                      mask={
                        showDataTo === 'fisica'
                          ? '999.999.999-99'
                          : '99.999.999/9999-99'
                      }
                      maskChar=''
                      onChange={(e) => handleChangeInfoTitularCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={12} md={6}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='phone' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Celular:
                    </label>
                    <InputMask
                      className='form-control'
                      name='phone'
                      id='phone'
                      value={infoTitularCartaoCredito.phone}
                      mask='(99) 9 9999-9999'
                      maskChar=''
                      onChange={(e) => handleChangeInfoTitularCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='postalCode' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      CEP:
                    </label>
                    <InputMask
                      className='form-control'
                      name='postalCode'
                      id='postalCode'
                      value={infoTitularCartaoCredito.postalCode}
                      mask='99999-999'
                      maskChar=''
                      onChange={(e) => handleChangeInfoTitularCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={12} md={6}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='addressNumber' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Número da residência:
                    </label>
                    <input
                      type='number'
                      className='form-control'
                      name='addressNumber'
                      id='addressNumber'
                      value={infoTitularCartaoCredito.addressNumber}
                      onChange={(e) => handleChangeInfoTitularCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '24px',
              paddingTop: '20px',
              borderTop: '1px solid #e2e8f0'
            }}>
              <button
                className='btn-voltar'
                onClick={() => setPassoSelecionado(passoSelecionado - 1)}
                type='button'
                style={{
                  background: 'transparent',
                  color: '#64748b',
                  border: '2px solid #e2e8f0',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease'
                }}
              >
                <i className='fa fa-arrow-left' style={{ marginRight: '6px' }}></i>
                Voltar
              </button>
              <button
                className='btn-proximo'
                onClick={() => handleFinishedInfoTitularCartao()}
                disabled={isTransitioning}
                type='button'
                style={{
                  background: isTransitioning ? '#94a3b8' : '#dc3545',
                  color: 'white',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '8px',
                  cursor: isTransitioning ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  boxShadow: isTransitioning ? 'none' : '0 4px 12px rgba(220, 53, 69, 0.25)',
                  opacity: isTransitioning ? 0.7 : 1
                }}
              >
                <span style={{
                  position: isTransitioning ? 'static' : 'absolute',
                  display: 'inline-flex',
                  alignItems: 'center',
                  opacity: isTransitioning ? 1 : 0,
                  visibility: isTransitioning ? 'visible' : 'hidden'
                }}>
                  <i className='fa fa-spinner fa-spin' style={{ marginRight: '6px' }}></i>
                  Aguarde...
                </span>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: isTransitioning ? 0 : 1,
                  visibility: isTransitioning ? 'hidden' : 'visible'
                }}>
                  Próximo
                  <i className='fa fa-arrow-right'></i>
                </span>
              </button>
            </div>
        </div>

        <div id='boxInfoCartao' style={{
          display: stepDadosPagamento === 'infoCartao' ? 'block' : 'none'
        }}>
            <div style={{ marginBottom: '24px' }}>
              <h5 style={{
                color: '#1e293b',
                fontWeight: '600',
                fontSize: '16px',
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <i className='fa fa-credit-card' style={{ color: '#dc3545' }}></i>
                Dados do cartão de crédito
              </h5>
              <p style={{ color: '#64748b', fontSize: '13px', margin: 0 }}>
                Insira os dados do seu cartão de crédito para finalizar
              </p>
            </div>
            <div>
              <h4>
                Preencha os campos abaixo com as informações do cartão de
                crédito para finalizar o pagamento:
              </h4>
              <div style={itemSeparatorTitle}></div>
              <Row>
                <Col sm={12}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='holderName' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Nome impresso no cartão:
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='holderName'
                      id='holderName'
                      placeholder='Como está no cartão'
                      value={infoCartaoCredito.holderName}
                      onChange={(e) => handleChangeInfoCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='number' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Número do cartão:
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='number'
                      id='number'
                      placeholder='0000 0000 0000 0000'
                      maxLength='16'
                      value={infoCartaoCredito.number}
                      onChange={(e) => handleChangeInfoCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='expiryMonth' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Mês
                    </label>
                    <select
                      className='form-control'
                      name='expiryMonth'
                      id='expiryMont'
                      value={infoCartaoCredito.expiryMonth}
                      onChange={(e) => handleChangeInfoCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <option value='01'>01</option>
                      <option value='02'>02</option>
                      <option value='03'>03</option>
                      <option value='04'>04</option>
                      <option value='05'>05</option>
                      <option value='06'>06</option>
                      <option value='07'>07</option>
                      <option value='08'>08</option>
                      <option value='09'>09</option>
                      <option value='10'>10</option>
                      <option value='11'>11</option>
                      <option value='12'>12</option>
                    </select>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='expiryYear' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      Ano
                    </label>
                    <select
                      className='form-control'
                      name='expiryYear'
                      id='expiryYear'
                      value={infoCartaoCredito.expiryYear}
                      onChange={(e) => handleChangeInfoCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {anos.map((item, i) => (
                        <option key={i} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup style={{ marginBottom: '16px' }}>
                    <label htmlFor='ccv' style={{
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block'
                    }}>
                      <span style={{ color: '#dc3545', marginRight: '4px' }}>*</span>
                      CVV
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='ccv'
                      id='ccv'
                      placeholder='000'
                      maxLength='4'
                      value={infoCartaoCredito.ccv}
                      onChange={(e) => handleChangeInfoCartao(e)}
                      required
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e2e8f0',
                        padding: '10px 12px',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '24px',
              paddingTop: '20px',
              borderTop: '1px solid #e2e8f0'
            }}>
              <button
                className='btn-voltar'
                onClick={() => setStepDadosPagamento('infoTitularCartao')}
                type='button'
                style={{
                  background: 'transparent',
                  color: '#64748b',
                  border: '2px solid #e2e8f0',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease'
                }}
              >
                <i className='fa fa-arrow-left' style={{ marginRight: '6px' }}></i>
                Voltar
              </button>
              <button
                className='btn-concluir'
                onClick={(e) => handleFinishedInfoCartao()}
                disabled={carregandoFinalizarPedido}
                type='button'
                style={{
                  background: carregandoFinalizarPedido ? '#94a3b8' : '#10b981',
                  color: 'white',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '8px',
                  cursor: carregandoFinalizarPedido ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  boxShadow: carregandoFinalizarPedido ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.25)'
                }}
              >
                <span style={{
                  position: carregandoFinalizarPedido ? 'static' : 'absolute',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: carregandoFinalizarPedido ? 1 : 0,
                  visibility: carregandoFinalizarPedido ? 'visible' : 'hidden'
                }}>
                  <i className='fa fa-spin fa-spinner'></i>
                  Finalizando...
                </span>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: carregandoFinalizarPedido ? 0 : 1,
                  visibility: carregandoFinalizarPedido ? 'hidden' : 'visible'
                }}>
                  <i className='fa fa-check'></i>
                  Finalizar Compra
                </span>
              </button>
            </div>
        </div>

        <div style={{
          display: formaPagamento === 'PIX' ? 'block' : 'none'
        }}>
            <div style={{
              background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
              padding: '32px',
              borderRadius: '12px',
              border: '2px solid #86efac',
              textAlign: 'center',
              marginBottom: '24px'
            }}>
              <div style={{
                width: '64px',
                height: '64px',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                boxShadow: '0 8px 20px rgba(16, 185, 129, 0.3)'
              }}>
                <i className='fa fa-qrcode' style={{ fontSize: '28px', color: 'white' }}></i>
              </div>
              <h5 style={{
                color: '#1e293b',
                fontWeight: '600',
                fontSize: '18px',
                marginBottom: '8px'
              }}>
                Pronto para finalizar!
              </h5>
              <p style={{
                color: '#475569',
                fontSize: '14px',
                marginBottom: 0,
                lineHeight: '1.6'
              }}>
                Clique em <strong>Finalizar</strong> para gerar o QR Code PIX e o código Copia e Cola.
                O pagamento é instantâneo e você receberá a confirmação imediatamente.
              </p>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingTop: '20px',
              borderTop: '1px solid #e2e8f0'
            }}>
              <button
                className='btn-voltar'
                onClick={() => setPassoSelecionado(passoSelecionado - 1)}
                type='button'
                style={{
                  background: 'transparent',
                  color: '#64748b',
                  border: '2px solid #e2e8f0',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease'
                }}
              >
                <i className='fa fa-arrow-left' style={{ marginRight: '6px' }}></i>
                Voltar
              </button>
              <button
                className='btn-concluir'
                onClick={() => handleSubmitPagamento()}
                disabled={carregandoFinalizarPedido}
                type='button'
                style={{
                  background: carregandoFinalizarPedido ? '#94a3b8' : '#10b981',
                  color: 'white',
                  border: 'none',
                  padding: '12px 28px',
                  borderRadius: '8px',
                  cursor: carregandoFinalizarPedido ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  boxShadow: carregandoFinalizarPedido ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.25)'
                }}
              >
                <span style={{
                  position: carregandoFinalizarPedido ? 'static' : 'absolute',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: carregandoFinalizarPedido ? 1 : 0,
                  visibility: carregandoFinalizarPedido ? 'visible' : 'hidden'
                }}>
                  <i className='fa fa-spin fa-spinner'></i>
                  Gerando QR Code...
                </span>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: carregandoFinalizarPedido ? 0 : 1,
                  visibility: carregandoFinalizarPedido ? 'hidden' : 'visible'
                }}>
                  <i className='fa fa-check'></i>
                  Finalizar
                </span>
              </button>
            </div>
        </div>

        <div style={{
          display: (formaPagamento !== 'PIX' && stepDadosPagamento !== 'infoTitularCartao' && stepDadosPagamento !== 'infoCartao') ? 'block' : 'none'
        }}>
            <div style={{
              background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
              padding: '32px',
              borderRadius: '12px',
              border: '2px solid #93c5fd',
              textAlign: 'center',
              marginBottom: '24px'
            }}>
              <div style={{
                width: '64px',
                height: '64px',
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)'
              }}>
                <i className='fa fa-envelope' style={{ fontSize: '28px', color: 'white' }}></i>
              </div>
              <h5 style={{
                color: '#1e293b',
                fontWeight: '600',
                fontSize: '18px',
                marginBottom: '8px'
              }}>
                Pronto para finalizar!
              </h5>
              <p style={{
                color: '#475569',
                fontSize: '14px',
                marginBottom: 0,
                lineHeight: '1.6'
              }}>
                Clique em <strong>Finalizar</strong> para concluir sua compra. Um e-mail com todas as
                informações de pagamento será enviado para{' '}
                <span style={{ fontWeight: '600', color: '#1e293b' }}>
                  {props.usuarioLogado.email}
                </span>
                .
              </p>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingTop: '20px',
              borderTop: '1px solid #e2e8f0'
            }}>
              <button
                className='btn-voltar'
                onClick={() => setPassoSelecionado(passoSelecionado - 1)}
                type='button'
                style={{
                  background: 'transparent',
                  color: '#64748b',
                  border: '2px solid #e2e8f0',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease'
                }}
              >
                <i className='fa fa-arrow-left' style={{ marginRight: '6px' }}></i>
                Voltar
              </button>
              <button
                className='btn-concluir'
                onClick={() => handleSubmitPagamento()}
                disabled={carregandoFinalizarPedido}
                type='button'
                style={{
                  background: carregandoFinalizarPedido ? '#94a3b8' : '#10b981',
                  color: 'white',
                  border: 'none',
                  padding: '12px 28px',
                  borderRadius: '8px',
                  cursor: carregandoFinalizarPedido ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  boxShadow: carregandoFinalizarPedido ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.25)'
                }}
              >
                <span style={{
                  position: carregandoFinalizarPedido ? 'static' : 'absolute',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: carregandoFinalizarPedido ? 1 : 0,
                  visibility: carregandoFinalizarPedido ? 'visible' : 'hidden'
                }}>
                  <i className='fa fa-spin fa-spinner'></i>
                  Finalizando...
                </span>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: carregandoFinalizarPedido ? 0 : 1,
                  visibility: carregandoFinalizarPedido ? 'hidden' : 'visible'
                }}>
                  <i className='fa fa-check'></i>
                  Finalizar
                </span>
              </button>
            </div>
        </div>
      </React.Fragment>
    );
  }

  // Proteção contra renderização em estado inválido
  if (!props || !props.contrato) {
    return null;
  }

  return (
    <React.Fragment>
      <ModalBody
        style={{
          background: 'transparent',
          padding: 0,
          border: 'none',
          boxShadow: 'none'
        }}
      >
        <div
          style={{
            maxWidth: 1100,
            margin: '0 auto',
            background: '#fff',
            borderRadius: 16,
            padding: 0,
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            overflow: 'hidden'
          }}
        >
          {_renderStepsHeader()}
          <div style={{ padding: 40 }}>
            {passoSelecionado === 1 && _renderPedido()}
            {passoSelecionado === 2 && _renderFormaPagamento()}
            {passoSelecionado === 3 && _renderDadosPagamento()}
          </div>
        </div>
      </ModalBody>
    </React.Fragment>
  );
}
